// import Lightbox from './Lightbox'
import { isNonemptyArray } from '../../utils/common'
import type { VFC } from 'react'

const SimpleGallery: VFC<{ images?: string[] }> = ({ images = [] }) => {
  if (!isNonemptyArray(images)) {
    return null
  }
  if (images.length > 4) { // hard limit for now
    images.length = 4
  }
  return (
    <div className='sparky-hub-app-gallery'>
      {images.map((img) =>
        <div key={img} className='sparky-hub-app-gallery-img-wrap'>
          <img
            className='sparky-hub-app-gallery-img'
            src={img}
            alt='screenshot'
          />
        </div>
      )}
    </div>
  )
}

export default SimpleGallery
